import { useEffect } from "react";

import { useUserAuth0Link } from "../../../hooks/useUser";
import { ROLES } from "../../../constants/roles";
import { MSG } from "../../../constants/msg";

import { isNotEmpty, useForm } from "@mantine/form";
import { Button, Grid, Paper, Text, Title } from "@mantine/core";
import RadioCard from "../../../components/ui/Form/RadioCard";
import { FaArrowRight } from "react-icons/fa";
import { RegisterProps } from "types/module/User/Onboarding";
import { RegisteredFormValues } from "types/module/User/Onboarding/Registered";

const Registered: React.FC<RegisterProps> = ({
  user,
  isSubmitting,
  setIsSubmitting,
  setOnboardStep,
  restartSteps,
}) => {
  const form = useForm<RegisteredFormValues>({
    initialValues: {
      role: ROLES?.find(role => role.default === true)?.value || null,
    },
    validate: {
      role: isNotEmpty(MSG.VALIDATE.REQUIRED("Role")),
    },
  });

  const {
    mutate: userUserAuth0LinkSendMutate,
    data: userUserAuth0LinkSendData,
    isSuccess: userUserAuth0LinkSendSuccess,
    isError: userUserAuth0LinkSendError,
  } = useUserAuth0Link(true);

  const handleDetailSubmit = (form: RegisteredFormValues) => {
    // @ts-ignore todo: for hooks ts migration
    userUserAuth0LinkSendMutate({
      name: user.firstName + " " + user.lastName,
      email: user.email,
      role: form.role,
    });

    setIsSubmitting(true);
  };

  useEffect(() => {
    if (userUserAuth0LinkSendSuccess || userUserAuth0LinkSendError) {
      if (userUserAuth0LinkSendSuccess && userUserAuth0LinkSendData) {
        form.reset();
        if (userUserAuth0LinkSendData.data?.isUser) {
          setOnboardStep("REGISTERED_EXIST");
        } else {
          setOnboardStep("REGISTERED_NEW");
        }
      }
      setIsSubmitting(false);
    }
  }, [userUserAuth0LinkSendSuccess, userUserAuth0LinkSendError]);

  return (
    <>
      <Title ta="center" c="black">
        Great news! We found a match for {user.firstName} in our system.
      </Title>
      <Text c="dimmed" size="lg" ta="center" mt={5}>
        Please select a permission profile to enable access.
      </Text>
      <Paper withBorder shadow="md" p={30} mt={30} radius="md">
        <form onSubmit={form.onSubmit((values: RegisteredFormValues) => handleDetailSubmit(values))}>
          <Grid>
            <Grid.Col>
              <RadioCard
                label="User Role"
                description="Which of the permission profiles below best matches the user's role?"
                data={ROLES}
                error={form.errors.role}
                {...form.getInputProps("role")}
              />
            </Grid.Col>
            <Grid.Col span={{ md: 8 }}>
              <Button
                type="submit"
                loading={isSubmitting}
                disabled={isSubmitting || !form.values.role?.trim()}
                rightSection={<FaArrowRight size={14} />}
                fullWidth
              >
                Proceed
              </Button>
            </Grid.Col>
            <Grid.Col span={{ md: 4 }}>
              <Button
                variant="default"
                onClick={restartSteps}
                disabled={isSubmitting}
                fullWidth
              >
                Cancel
              </Button>
            </Grid.Col>
          </Grid>
        </form>
      </Paper>
    </>
  );
};

export default Registered;
